// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1D7zR","content":"RecentSearches_content__2QjL5"};